<div class="container">
  <mat-card style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <div class="row">
        <div class="col-md-6">
          <h1 class="mt-5">Data Layouts</h1>
          <div *ngIf="loadingData">
            <i class="fas fa-spinner fa-pulse"></i> Loading Layout Data, Please Wait...
          </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-4" style="margin-top: 6px">
          <a *ngIf="hasActiveSubscription" href="#" (click)="createLayout();"><span class="fas fa-file" title="Create New Layout">&nbsp;&nbsp;Create New Layout</span></a>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 mainLabel"></div>
        <div class="col-md-3 mainLabel">Layout Name</div>
        <div class="col-md-3 mainLabel">Owner</div>
        <div class="col-md-4 mainLabel">Export Status</div>
      </div>
      <ng-container *ngIf="currentLayouts">
        <ng-container *ngFor="let layout of currentLayouts">
          <div class="row table-row">
            <div class="col-md-2" style="margin-top: 5px">
              <ng-container *ngIf="!layout.subscriptionExpired">
              <a *ngIf="!startingIds.has(layout.dodBatchLayoutId)" href="#" (click)="exportNow(layout)"><span class="fas fa-print" title="Configure & Export Now"></span></a>
              <span *ngIf="startingIds.has(layout.dodBatchLayoutId)" class="fas fa-print text-muted" title="Export is starting"></span>&nbsp;
              </ng-container>
              <ng-container *ngIf="layout.allowEditing && !layout.subscriptionExpired">
                <a href="#" (click)="editLayout(layout)"><span class="fas fa-edit" title="Edit"></span></a>&nbsp;
              </ng-container>
              <ng-container *ngIf="layout.isOwner">
                <a href="#" (click)="deleteLayout(layout)"><span class="fas fa-trash" title="Delete"></span></a>&nbsp;
              </ng-container>
              <ng-container *ngIf="!layout.recurring && !layout.subscriptionExpired">
                <a href="#" (click)="createRecurring(layout)"><span class="fas fa-calendar-plus" title="Create Scheduled Export"></span></a>
              </ng-container>
              <ng-container *ngIf="layout.recurring">
                <a *ngIf="!layout.subscriptionExpired" href="#" (click)="editRecurring(layout.recurring)"><span class="fas fa-calendar-day" title="Edit Scheduled Export"></span></a>&nbsp;
                <a href="#" (click)="deleteRecurring(layout.recurring)"><span class="fas fa-calendar-times" title="Delete Scheduled Export"></span></a>
              </ng-container>
            </div>
            <div class="col-md-3">{{ layout.name }}</div>
            <div class="col-md-3">{{ layout.createdBy }} / {{ layout.organizationName }}</div>
            <div class="col-md-4">
              <span *ngIf="layout.subscriptionExpired" class="text-danger">Subscription expired</span>
              <ng-container *ngIf="!layout.subscriptionExpired">
                <i *ngIf="startingIds.has(layout.dodBatchLayoutId)" class="fas fa-spinner fa-pulse"></i>
                <span [class.text-danger]="isErrorText(layout.exportStatus)">{{ layout.exportStatus }}</span>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
